/* MugPress — behaviour for the mp- sections: countdown, product gallery,
   bundle picker with add-ons, add to cart into the drawer, sticky bar.
   Every part finds its own markup and does nothing when it is missing, and
   everything re-runs when the theme editor reloads a section. */
(function () {
  'use strict';

  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- countdown ----------
     data-end is a unix timestamp from the theme editor's end date; with
     data-mode="daily" the clock runs to the visitor's next midnight, and
     with data-mode="visitor" every visitor gets data-duration seconds from
     their first view, kept in localStorage and started again when it runs
     out. The days box hides while there are no whole days left. */
  function initCountdown(el) {
    if (el.dataset.mpReady) return;
    el.dataset.mpReady = '1';
    var mode = el.dataset.mode;
    var end = Number(el.dataset.end) * 1000;
    var span = Number(el.dataset.duration) * 1000;
    var key = 'mp-countdown-' + (el.dataset.key || 'end');
    if (mode === 'date' && !end) { el.classList.add('is-over'); return; }
    if (mode === 'visitor' && !span) { el.classList.add('is-over'); return; }
    var unit = function (name) { return el.querySelector('[data-unit="' + name + '"]'); };
    var parts = { d: unit('d'), h: unit('h'), m: unit('m'), s: unit('s') };
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var timer;
    var visitorEnd = 0;
    function target() {
      if (mode === 'daily') {
        var t = new Date();
        t.setHours(24, 0, 0, 0);
        return t.getTime();
      }
      if (mode === 'visitor') {
        if (!visitorEnd) {
          try { visitorEnd = Number(window.localStorage.getItem(key)) || 0; } catch (e) { visitorEnd = 0; }
        }
        if (visitorEnd - Date.now() < 1000) {
          visitorEnd = Date.now() + span;
          try { window.localStorage.setItem(key, String(visitorEnd)); } catch (e) { /* counts from this view */ }
        }
        return visitorEnd;
      }
      return end;
    }
    function tick() {
      var left = Math.floor((target() - Date.now()) / 1000);
      if (left <= 0) {
        el.classList.add('is-over');
        clearInterval(timer);
        return;
      }
      var days = Math.floor(left / 86400);
      if (parts.d) {
        parts.d.textContent = pad(days);
        parts.d.parentNode.hidden = days === 0;
      }
      if (parts.h) parts.h.textContent = pad(Math.floor((left % 86400) / 3600));
      if (parts.m) parts.m.textContent = pad(Math.floor((left % 3600) / 60));
      if (parts.s) parts.s.textContent = pad(left % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- gallery ----------
     A scroll-snap strip, so a phone swipes it natively; the arrows and
     thumbnails just scroll it, and scrolling keeps the thumbnails in step. */
  function initGallery(gallery) {
    if (gallery.dataset.mpReady) return;
    gallery.dataset.mpReady = '1';
    var track = gallery.querySelector('[data-mp-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-mp-slide]');
    var thumbs = gallery.querySelectorAll('[data-mp-thumb]');
    var current = 0;

    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      if (i === current) return;
      current = i;
      each(thumbs, function (t, n) {
        if (n === i) {
          t.setAttribute('aria-current', 'true');
          var strip = t.parentNode;
          var left = t.offsetLeft - (strip.clientWidth - t.clientWidth) / 2;
          strip.scrollTo({ left: left, behavior: 'smooth' });
        } else {
          t.removeAttribute('aria-current');
        }
      });
      each(slides, function (s, n) {
        var v = s.querySelector('video');
        if (!v) return;
        if (n === i) { v.play && v.play().catch(function () {}); } else { v.pause && v.pause(); }
      });
    }

    var frame;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      });
    }, { passive: true });

    var prev = gallery.querySelector('[data-mp-prev]');
    var next = gallery.querySelector('[data-mp-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    each(thumbs, function (t, n) { t.addEventListener('click', function () { go(n); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    });

    gallery.mpGo = go;
  }

  /* ---------- review slider ----------
     Same idea as the gallery: a scroll-snap strip a phone swipes, arrows
     that scroll it (wrapping round) and dots that follow the scroll. */
  function initQuotes(box) {
    if (box.dataset.mpReady) return;
    box.dataset.mpReady = '1';
    var track = box.querySelector('[data-mp-quotes-track]');
    if (!track) return;
    var cards = track.children;
    var dots = box.querySelectorAll('[data-mp-quotes-dots] > span');
    var current = 0;
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function go(i) {
      if (!cards.length) return;
      i = (i + cards.length) % cards.length;
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    var frame;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        current = Math.round(track.scrollLeft / Math.max(1, step()));
        each(dots, function (d, n) { d.classList.toggle('is-on', n === current); });
      });
    }, { passive: true });
    var prev = box.querySelector('[data-mp-quotes-prev]');
    var next = box.querySelector('[data-mp-quotes-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
  }

  /* ---------- cart drawer ----------
     After an add, the drawer is re-rendered through the section rendering API
     before it opens, so it shows the cart as it is now. The count bubble in the
     header comes along in the same request. Falls back to the cart page. */
  function refreshCart(open) {
    var host = document.getElementById('shopify-section-cart-drawer');
    if (!host || !window.fetch) { if (open) window.location.href = root + 'cart'; return Promise.resolve(); }
    var wasOpen = !!document.querySelector('cart-drawer.active');
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parse = function (html, id) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          return id ? doc.getElementById(id) : doc.querySelector('.shopify-section');
        };
        var fresh = parse(sections['cart-drawer'], 'shopify-section-cart-drawer');
        if (fresh) host.innerHTML = fresh.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleFresh = parse(sections['cart-icon-bubble']);
        if (bubble && bubbleFresh) bubble.innerHTML = bubbleFresh.innerHTML;
        if (typeof window.snCartTimerBoot === 'function') window.snCartTimerBoot();
        if (!open && !wasOpen) return; /* a quiet redraw leaves a closed drawer closed, an open one open */
        var drawer = document.querySelector('cart-drawer');
        if (!drawer) { window.location.href = root + 'cart'; return; }
        if (typeof drawer.open === 'function') {
          try { drawer.open(); return; } catch (e) { /* fall through to the classes */ }
        }
        drawer.classList.add('active');
        drawer.classList.remove('is-empty');
        document.body.classList.add('overflow-hidden');
      })
      .catch(function () { if (open) window.location.href = root + 'cart'; });
  }
  function openCartDrawer() { return refreshCart(true); }

  /* ---------- product: bundles, a colour per printer, add-ons, add to cart ----------
     A bundle radio carries the number of printers. Inside the chosen bundle
     every printer has its own colour select; the cart gets one line per
     colour with the right quantity, and Shopify's automatic bundle discounts
     bring the total down to the bundle price shown on the card. */
  function initProduct(section) {
    if (section.dataset.mpReady) return;
    section.dataset.mpReady = '1';
    var form = section.querySelector('[data-mp-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var radios = section.querySelectorAll('[data-mp-bundle]');
    var addonPanel = section.querySelector('[data-mp-addons]');
    var now = section.querySelector('[data-mp-now]');
    var was = section.querySelector('[data-mp-was]');
    var save = section.querySelector('[data-mp-save]');
    var error = section.querySelector('[data-mp-error]');
    var buttons = section.querySelectorAll('[data-mp-atc]');
    var sticky = section.querySelector('[data-mp-sticky]');
    var stickyPrice = section.querySelector('[data-mp-sticky-price]');
    var gallery = section.querySelector('[data-mp-gallery]');
    var saveTemplate = save ? save.dataset.template || '[amount]' : '';
    var saveLine = section.querySelector('[data-mp-save-line]');
    var saveLineText = saveLine ? saveLine.querySelector('[data-mp-save-line-text]') : null;
    function fill(template, d) { return template.replace('[amount]', d.save).replace('[percent]', d.percent || ''); }
    var picked = []; /* the colour last chosen for printer 1, 2, 3 */

    function setText(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function cardOf(radio) { return radio.parentNode; }
    function selectsOf(radio) { return cardOf(radio).querySelectorAll('[data-mp-unit]'); }

    /* the small photo next to a select follows the colour picked in it */
    function syncThumb(select) {
      var option = select.options[select.selectedIndex];
      var img = select.parentNode.querySelector('.mp-unit__img img');
      if (img && option && option.dataset.img) img.src = option.dataset.img;
    }

    /* jump the gallery to a colour's photo */
    function showMedia(mediaId) {
      if (!gallery || !gallery.mpGo || !mediaId) return;
      var slides = gallery.querySelectorAll('[data-mp-slide]');
      for (var n = 0; n < slides.length; n++) {
        if (slides[n].dataset.mediaId === String(mediaId)) { gallery.mpGo(n); return; }
      }
    }

    /* every printer position keeps its own colour, so going down to a
       smaller bundle and back up does not reset the printers beyond it */
    function remember(radio) {
      each(selectsOf(radio), function (s, i) { picked[i] = s.value; });
    }

    function choose(radio) {
      var d = radio.dataset;
      setText(now, d.price);
      setText(was, d.compare);
      setText(save, d.save ? fill(saveTemplate, d) : '');
      if (saveLine && saveLineText) {
        saveLineText.textContent = d.save ? fill(saveLine.dataset.template, d) : '';
        saveLine.hidden = !d.save;
      }
      setText(stickyPrice, d.price);
      /* a bigger bundle starts from the colours already picked */
      each(selectsOf(radio), function (s, i) {
        var want = picked[i] || picked[picked.length - 1];
        if (want && s.querySelector('option[value="' + want + '"]:not([disabled])')) s.value = want;
        syncThumb(s);
      });
      remember(radio);
      /* the add-ons travel with the chosen bundle, the way Latte Print shows them */
      var slot = cardOf(radio).querySelector('[data-mp-addon-slot]');
      if (addonPanel && slot && addonPanel.parentNode !== slot) slot.appendChild(addonPanel);
      var soldOut = d.available !== 'true';
      each(buttons, function (b) {
        b.disabled = soldOut;
        var label = b.querySelector('[data-mp-atc-label]');
        if (label) label.textContent = soldOut ? (b.dataset.soldOut || 'Sold out') : (b.dataset.label || label.textContent);
      });
    }

    each(radios, function (r) {
      r.addEventListener('change', function () { if (r.checked) choose(r); });
      each(selectsOf(r), function (s) {
        s.addEventListener('change', function () {
          syncThumb(s);
          if (r.checked) remember(r);
          var option = s.options[s.selectedIndex];
          if (option) showMedia(option.dataset.media);
        });
      });
    });
    var first = section.querySelector('[data-mp-bundle]:checked') || radios[0];
    if (first) {
      first.checked = true;
      remember(first);
      choose(first);
    }

    each(section.querySelectorAll('[data-mp-addon-input]'), function (box) {
      var row = box.closest('.mp-addon');
      var sync = function () { if (row) row.classList.toggle('is-on', box.checked); };
      box.addEventListener('change', sync);
      sync();
    });

    /* coffee kit: a live toggle. Switching an item on puts it in the cart at
       once (/cart/update.js with the absolute quantity), off takes it out, the
       stepper sets the number of sets while it is on, and whatever the cart
       drawer does to the line (its bin, its stepper) flows back into the
       toggle, so the page and the cart never disagree. */
    var kit = section.querySelector('.mp-kit');
    /* the kit prices are formatted from a sample of the live money format
       ("$1,234.56 CAD", "€1.234,56 EUR"): prefix, separators and the currency
       code come from it, so the stepper total matches the market the visitor
       is in (shop.money_format only knows the store currency) */
    var moneySample = kit ? kit.dataset.moneySample || '' : '';
    var moneyParts = moneySample.match(/^(.*?)1(\D?)23[45](?:(\D)56)?(.*)$/);
    function formatMoney(cents) {
      var n = cents / 100;
      if (!moneyParts) return n.toFixed(2);
      var decimals = moneyParts[3] ? 2 : 0;
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts[2] || '');
      return moneyParts[1] + parts[0] + (moneyParts[3] ? moneyParts[3] + parts[1] : '') + moneyParts[4];
    }
    function kitSet(item, quantity) {
      var box = item.querySelector('[data-mp-kit-input]');
      var id = box ? Number(box.value) : 0;
      if (!id || !window.fetch) return Promise.resolve();
      var updates = {};
      updates[id] = quantity;
      item.classList.add('is-busy');
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return refreshCart(false); })
        .catch(function () { return syncKit(); }) /* the toggle goes back to what the cart says */
        .then(function () { item.classList.remove('is-busy'); });
    }
    /* the toggles follow the cart: on load and after every change the drawer makes */
    function syncKit() {
      if (!kit || !window.fetch) return Promise.resolve();
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = {};
          each(cart.items || [], function (l) { inCart[l.variant_id] = (inCart[l.variant_id] || 0) + l.quantity; });
          each(section.querySelectorAll('.mp-kit__item'), function (item) {
            var box = item.querySelector('[data-mp-kit-input]');
            var count = item.querySelector('[data-mp-kit-count]');
            if (!box) return;
            var qty = inCart[Number(box.value)] || 0;
            box.checked = qty > 0;
            if (count && qty > 0) count.value = qty;
            if (typeof item.mpSettle === 'function') item.mpSettle();
          });
        })
        .catch(function () { /* the toggles keep what they have */ });
    }
    each(section.querySelectorAll('.mp-kit__item'), function (item) {
      var box = item.querySelector('[data-mp-kit-input]');
      var count = item.querySelector('[data-mp-kit-count]');
      var price = item.querySelector('[data-mp-kit-price]');
      var settle = function () {
        if (!count) return;
        var max = Number(count.max) || 10;
        var value = Math.round(Number(count.value) || 1);
        count.value = Math.min(max, Math.max(1, value));
        if (price && moneyParts) price.textContent = formatMoney(Number(price.dataset.unit) * Number(count.value));
      };
      var sets = function () { return count ? Math.max(1, Math.round(Number(count.value) || 1)) : 1; };
      item.mpSettle = settle;
      if (box) {
        box.addEventListener('change', function () {
          if (box.disabled) return;
          kitSet(item, box.checked ? sets() : 0);
        });
      }
      if (count) {
        each(item.querySelectorAll('[data-mp-step]'), function (b) {
          b.addEventListener('click', function () {
            count.value = (Number(count.value) || 1) + Number(b.dataset.mpStep);
            settle();
            if (box && box.checked) kitSet(item, sets());
          });
        });
        count.addEventListener('change', function () {
          settle();
          if (box && box.checked) kitSet(item, sets());
        });
      }
      settle();
    });
    syncKit();
    var drawerHost = document.getElementById('shopify-section-cart-drawer');
    if (kit && drawerHost && 'MutationObserver' in window) {
      var kitTimer;
      new MutationObserver(function () {
        clearTimeout(kitTimer);
        kitTimer = setTimeout(syncKit, 400);
      }).observe(drawerHost, { childList: true, subtree: true });
    }

    function busy(state) {
      each(buttons, function (b) {
        b.classList.toggle('is-busy', state);
        if (state) b.disabled = true;
      });
      if (!state) {
        var checked = section.querySelector('[data-mp-bundle]:checked');
        if (checked) choose(checked); else each(buttons, function (b) { b.disabled = false; });
      }
    }

    /* one cart line per colour: two white and one green become 2 x white, 1 x green */
    function printerLines() {
      var checked = section.querySelector('[data-mp-bundle]:checked');
      var qty = checked ? Number(checked.value) || 1 : 1;
      var selects = checked ? selectsOf(checked) : [];
      var counts = {};
      var order = [];
      if (selects.length) {
        each(selects, function (s) {
          if (!counts[s.value]) { counts[s.value] = 0; order.push(s.value); }
          counts[s.value] += 1;
        });
      } else if (idInput && Number(idInput.value)) {
        counts[idInput.value] = qty;
        order.push(idInput.value);
      }
      return order.map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; /* the plain POST adds the default colour */
      var items = printerLines();
      if (!items.length) return;
      e.preventDefault();
      if (error) error.hidden = true;
      each(section.querySelectorAll('[data-mp-addon-input]:checked'), function (box) {
        if (Number(box.value)) items.push({ id: Number(box.value), quantity: 1 });
      });
      /* the coffee kit is not added here: its toggles put it in the cart as they are switched */
      /* the cart drawer arranges its colour selects by this: the printers
         already there keep their places, the new ones follow in the order
         picked here */
      try {
        var order = JSON.parse(window.localStorage.getItem('mp-cart-colour-order') || '[]');
        var checkedBundle = section.querySelector('[data-mp-bundle]:checked');
        each(checkedBundle ? selectsOf(checkedBundle) : [], function (s) { order.push(s.value); });
        if (!checkedBundle && idInput) { order.push(idInput.value); }
        window.localStorage.setItem('mp-cart-colour-order', JSON.stringify(order));
      } catch (err) { /* no storage: the drawer falls back to cart order */ }
      busy(true);
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('mp:added', { detail: { items: items } }));
          return openCartDrawer();
        })
        .catch(function (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
        })
        .then(function () { busy(false); });
    });

    /* the sticky bar slides in once the real button has scrolled off the top */
    var mainButton = form.querySelector('[data-mp-atc]');
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainButton);
    }
  }

  /* ---------- header ----------
     It sticks to the top in CSS; once it is stuck it gets a soft shadow. */
  function initHeader(header) {
    if (header.dataset.mpReady) return;
    header.dataset.mpReady = '1';
    var frame;
    function check() {
      header.classList.toggle('is-stuck', window.scrollY > 0 && header.getBoundingClientRect().top <= 0);
    }
    window.addEventListener('scroll', function () {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(check);
    }, { passive: true });
    check();
  }

  /* ---------- prints row ----------
     A clip gets its file the first time it comes on screen and plays only
     while a third of it is visible. */
  function initPrints(section) {
    if (section.dataset.mpReady) return;
    section.dataset.mpReady = '1';
    var videos = section.querySelectorAll('video[data-src]');
    function start(v) {
      if (!v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    if (!('IntersectionObserver' in window)) { each(videos, start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) start(e.target);
        else if (!e.target.paused) e.target.pause();
      });
    }, { threshold: 0.33 });
    each(videos, function (v) { io.observe(v); });
  }

  /* ---------- review wall ----------
     "Show more" reveals the next batch of hidden cards. */
  function initWall(section) {
    if (section.dataset.mpReady) return;
    section.dataset.mpReady = '1';
    var btn = section.querySelector('[data-mp-wall-more]');
    if (!btn) return;
    var step = Number(section.dataset.step) || 8;
    btn.addEventListener('click', function () {
      var later = section.querySelectorAll('[data-mp-wall-later][hidden]');
      for (var i = 0; i < later.length && i < step; i++) later[i].hidden = false;
      if (later.length <= step) btn.hidden = true;
    });
  }

  function init(scope) {
    scope = scope || document;
    each(scope.querySelectorAll('[data-mp-wall]'), initWall);
    each(scope.querySelectorAll('[data-mp-prints]'), initPrints);
    each(scope.querySelectorAll('[data-mp-header]'), initHeader);
    each(scope.querySelectorAll('[data-mp-countdown]'), initCountdown);
    each(scope.querySelectorAll('[data-mp-gallery]'), initGallery);
    each(scope.querySelectorAll('[data-mp-quotes]'), initQuotes);
    each(scope.querySelectorAll('[data-mp-product]'), initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
